import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Trophy, Zap, Star, Crown, Sparkles, Home, User, BookOpen, ArrowLeft, Volume2, VolumeX } from 'lucide-react';

// Bible trivia questions database with updated categories
const QUESTIONS = [
  // OLD TESTAMENT
  {
    category: 'Old Testament',
    question: 'Who built the ark to survive the great flood?',
    options: ['Moses', 'Noah', 'Abraham', 'David'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Old Testament',
    question: 'What did God create on the first day?',
    options: ['Light', 'Land', 'Animals', 'Humans'],
    correct: 0,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Old Testament',
    question: 'Who led the Israelites out of Egypt?',
    options: ['Joshua', 'Moses', 'Aaron', 'Caleb'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Old Testament',
    question: 'What did God give Moses on Mount Sinai?',
    options: ['The Ark', 'Ten Commandments', 'A sword', 'A crown'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Old Testament',
    question: 'Who was the first man created by God?',
    options: ['Abel', 'Cain', 'Adam', 'Noah'],
    correct: 2,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Old Testament',
    question: 'How many days and nights did it rain during the great flood?',
    options: ['7', '30', '40', '100'],
    correct: 2,
    difficulty: 'medium',
    points: 200
  },
  {
    category: 'Old Testament',
    question: 'Who was the first king of Israel?',
    options: ['David', 'Solomon', 'Saul', 'Samuel'],
    correct: 2,
    difficulty: 'medium',
    points: 200
  },
  {
    category: 'Old Testament',
    question: 'How many plagues did God send to Egypt?',
    options: ['7', '10', '12', '15'],
    correct: 1,
    difficulty: 'medium',
    points: 200
  },

  // NEW TESTAMENT
  {
    category: 'New Testament',
    question: 'How many apostles did Jesus choose?',
    options: ['10', '12', '7', '24'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'New Testament',
    question: 'Where was Jesus born?',
    options: ['Jerusalem', 'Nazareth', 'Bethlehem', 'Galilee'],
    correct: 2,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'New Testament',
    question: 'Who baptized Jesus?',
    options: ['Peter', 'James', 'John the Baptist', 'Andrew'],
    correct: 2,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'New Testament',
    question: 'Who denied Jesus three times?',
    options: ['Judas', 'Peter', 'John', 'Thomas'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'New Testament',
    question: 'On which day did Jesus rise from the dead?',
    options: ['Friday', 'Saturday', 'Sunday', 'Monday'],
    correct: 2,
    difficulty: 'medium',
    points: 200
  },
  {
    category: 'New Testament',
    question: 'How many days did Jesus fast in the wilderness?',
    options: ['30', '40', '50', '60'],
    correct: 1,
    difficulty: 'medium',
    points: 200
  },

  // PROPHETS
  {
    category: 'Prophets',
    question: 'Who was swallowed by a great fish?',
    options: ['Jonah', 'Elijah', 'Isaiah', 'Jeremiah'],
    correct: 0,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Prophets',
    question: 'Which prophet was taken up to heaven in a whirlwind?',
    options: ['Elisha', 'Elijah', 'Isaiah', 'Ezekiel'],
    correct: 1,
    difficulty: 'medium',
    points: 200
  },
  {
    category: 'Prophets',
    question: 'Which prophet saw a vision of dry bones coming to life?',
    options: ['Isaiah', 'Jeremiah', 'Ezekiel', 'Daniel'],
    correct: 2,
    difficulty: 'medium',
    points: 200
  },
  {
    category: 'Prophets',
    question: 'Which prophet confronted King Ahab about Naboth\'s vineyard?',
    options: ['Elijah', 'Elisha', 'Nathan', 'Samuel'],
    correct: 0,
    difficulty: 'hard',
    points: 300
  },

  // MIRACLES
  {
    category: 'Miracles',
    question: 'What did Jesus turn water into at a wedding?',
    options: ['Wine', 'Milk', 'Oil', 'Juice'],
    correct: 0,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Miracles',
    question: 'What sea did Moses part?',
    options: ['Dead Sea', 'Red Sea', 'Mediterranean', 'Sea of Galilee'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Miracles',
    question: 'Who walked on water with Jesus?',
    options: ['John', 'Peter', 'James', 'Andrew'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Miracles',
    question: 'How many loaves of bread did Jesus use to feed the 5000?',
    options: ['2', '5', '7', '12'],
    correct: 1,
    difficulty: 'medium',
    points: 200
  },
  {
    category: 'Miracles',
    question: 'Who did Jesus raise from the dead in Bethany?',
    options: ['Jairus', 'Lazarus', 'The widow\'s son', 'Peter'],
    correct: 1,
    difficulty: 'medium',
    points: 200
  },

  // PARABLES
  {
    category: 'Parables',
    question: 'In the parable of the Good Samaritan, who helped the injured man?',
    options: ['A priest', 'A Levite', 'A Samaritan', 'A merchant'],
    correct: 2,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Parables',
    question: 'In the parable of the Prodigal Son, what did the son ask for?',
    options: ['Food', 'His inheritance', 'A job', 'Forgiveness'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Parables',
    question: 'What did the wise man build his house on?',
    options: ['Sand', 'Rock', 'Wood', 'Clay'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Parables',
    question: 'In the parable of the sower, where did some seeds fall?',
    options: ['Rocky ground', 'Good soil', 'Among thorns', 'All of these'],
    correct: 3,
    difficulty: 'medium',
    points: 200
  },

  // CHARACTERS
  {
    category: 'Characters',
    question: 'Who was thrown into a den of lions?',
    options: ['David', 'Daniel', 'Jonah', 'Job'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Characters',
    question: 'Who was the mother of Jesus?',
    options: ['Martha', 'Mary', 'Elizabeth', 'Ruth'],
    correct: 1,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Characters',
    question: 'Who defeated Goliath with a sling and stone?',
    options: ['Saul', 'Jonathan', 'David', 'Samuel'],
    correct: 2,
    difficulty: 'easy',
    points: 100
  },
  {
    category: 'Characters',
    question: 'Who was the strongest man in the Bible?',
    options: ['Goliath', 'David', 'Samson', 'Joshua'],
    correct: 2,
    difficulty: 'medium',
    points: 200
  },
  {
    category: 'Characters',
    question: 'Who interpreted dreams for Pharaoh in Egypt?',
    options: ['Moses', 'Joseph', 'Daniel', 'Ezekiel'],
    correct: 1,
    difficulty: 'medium',
    points: 200
  },
  {
    category: 'Characters',
    question: 'Who was sold into slavery by his brothers?',
    options: ['Benjamin', 'Joseph', 'Jacob', 'Judah'],
    correct: 1,
    difficulty: 'medium',
    points: 200
  }
];

const CATEGORY_INFO = {
  'Old Testament': { color: '#FF9F43', icon: '📖' },
  'New Testament': { color: '#5DADE2', icon: '✨' },
  'Prophets': { color: '#C39BD3', icon: '👑' },
  'Miracles': { color: '#F8B4D9', icon: '⚡' },
  'Parables': { color: '#7DCEA0', icon: '💬' },
  'Characters': { color: '#85C1E9', icon: '👥' }
};

const WizdomTrivia = () => {
  const [screen, setScreen] = useState('home');
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [streak, setStreak] = useState(0);
  const [currentStreak, setCurrentStreak] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [leaderboard, setLeaderboard] = useState([]);
  const [gameComplete, setGameComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tempName, setTempName] = useState('');
  const [isMuted, setIsMuted] = useState(false);

  // Audio refs
  const bgMusicRef = useRef(null);
  const correctSoundRef = useRef(null);
  const wrongSoundRef = useRef(null);

  const API_URL = 'https://wizdomtriviaapp-production.up.railway.app/api';

  // Audio Management
  useEffect(() => {
    // Initialize audio elements with actual files
    
    // Background music
    const bgMusic = new Audio('/audio/background-music.mp3');
    bgMusic.loop = true;
    bgMusic.volume = 0.3;
    bgMusicRef.current = bgMusic;

    // Correct answer sound
    const correctSound = new Audio('/audio/correct.mp3');
    correctSound.volume = 0.5;
    correctSoundRef.current = correctSound;

    // Wrong answer sound
    const wrongSound = new Audio('/audio/wrong.mp3');
    wrongSound.volume = 0.5;
    wrongSoundRef.current = wrongSound;

    // Load mute preference
    const savedMute = localStorage.getItem('wizdomMuted');
    if (savedMute === 'true') {
      setIsMuted(true);
    }

    return () => {
      if (bgMusicRef.current) {
        bgMusicRef.current.pause();
      }
    };
  }, []);

  // Control background music based on screen
  useEffect(() => {
    if (isMuted) {
      if (bgMusicRef.current) {
        bgMusicRef.current.pause();
      }
      return;
    }

    // Play music on home and categories screens
    if (screen === 'home' || screen === 'categories') {
      if (bgMusicRef.current) {
        // Try to play (some browsers require user interaction first)
        bgMusicRef.current.play().catch(err => {
          console.log('Audio autoplay prevented:', err);
        });
      }
    } else {
      // Pause on other screens
      if (bgMusicRef.current) {
        bgMusicRef.current.pause();
      }
    }
  }, [screen, isMuted]);

  // Play sound effects
  const playCorrectSound = () => {
    if (!isMuted && correctSoundRef.current) {
      correctSoundRef.current.currentTime = 0;
      correctSoundRef.current.play().catch(err => console.log('Sound play error:', err));
    }
  };

  const playWrongSound = () => {
    if (!isMuted && wrongSoundRef.current) {
      wrongSoundRef.current.currentTime = 0;
      wrongSoundRef.current.play().catch(err => console.log('Sound play error:', err));
    }
  };

  const toggleMute = () => {
    const newMuted = !isMuted;
    setIsMuted(newMuted);
    localStorage.setItem('wizdomMuted', newMuted.toString());
    
    if (newMuted && bgMusicRef.current) {
      bgMusicRef.current.pause();
    } else if (!newMuted && (screen === 'home' || screen === 'categories') && bgMusicRef.current) {
      bgMusicRef.current.play().catch(err => console.log('Audio play error:', err));
    }
  };

  // Load user profile and leaderboard
  const loadUserProfile = useCallback(() => {
    const saved = localStorage.getItem('wizdomProfile');
    if (saved) {
      setUserProfile(JSON.parse(saved));
    } else {
      // Create default profile
      const defaultProfile = {
        name: 'Player',
        totalPoints: 0,
        bestStreak: 0,
        gamesPlayed: 0,
        avatar: generateAvatar('Player')
      };
      localStorage.setItem('wizdomProfile', JSON.stringify(defaultProfile));
      setUserProfile(defaultProfile);
    }
  }, []);

  useEffect(() => {
    loadUserProfile();
    fetchLeaderboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadUserProfile]);

  const generateAvatar = (name) => {
    const initial = name.charAt(0).toUpperCase();
    const colors = ['#FF6B6B', '#4ECDC4', '#FFE66D', '#A8E6CF', '#C77DFF', '#FF9F43'];
    const color = colors[initial.charCodeAt(0) % colors.length];
    return { initial, color };
  };

  const updateProfile = (updates) => {
    const updated = { ...userProfile, ...updates };
    if (updates.name) {
      updated.avatar = generateAvatar(updates.name);
    }
    setUserProfile(updated);
    localStorage.setItem('wizdomProfile', JSON.stringify(updated));
  };

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/leaderboard?limit=10`);
      const data = await response.json();
      if (data.success) {
        setLeaderboard(data.data);
      }
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
      const saved = localStorage.getItem('wizdomLeaderboard');
      if (saved) {
        setLeaderboard(JSON.parse(saved));
      }
    } finally {
      setLoading(false);
    }
  };

  const startGame = (category = null) => {
    setSelectedCategory(category);
    let filteredQuestions = QUESTIONS;
    
    if (category && category !== 'Mix It Up') {
      filteredQuestions = QUESTIONS.filter(q => q.category === category);
    }
    
    const shuffled = [...filteredQuestions].sort(() => Math.random() - 0.5).slice(0, 10);
    setQuestions(shuffled);
    setCurrentQuestion(0);
    setScore(0);
    setCurrentStreak(0);
    setGameComplete(false);
    setScreen('game');
  };

  const handleAnswer = (index) => {
    if (showResult) return;
    
    setSelectedAnswer(index);
    setShowResult(true);
    
    const isCorrect = index === questions[currentQuestion].correct;
    
    // Play sound effect
    if (isCorrect) {
      playCorrectSound();
    } else {
      playWrongSound();
    }
    
    if (isCorrect) {
      const newStreak = currentStreak + 1;
      const bonusPoints = newStreak >= 3 ? 50 : 0;
      setScore(score + questions[currentQuestion].points + bonusPoints);
      setCurrentStreak(newStreak);
      
      if (newStreak > streak) {
        setStreak(newStreak);
      }
    } else {
      setCurrentStreak(0);
    }

    setTimeout(() => {
      if (currentQuestion < questions.length - 1) {
        setCurrentQuestion(currentQuestion + 1);
        setSelectedAnswer(null);
        setShowResult(false);
      } else {
        finishGame();
      }
    }, 2000);
  };

  const finishGame = async () => {
    const newGamesPlayed = userProfile.gamesPlayed + 1;
    const newTotalPoints = userProfile.totalPoints + score;
    const newBestStreak = Math.max(userProfile.bestStreak, streak);
    
    updateProfile({
      totalPoints: newTotalPoints,
      bestStreak: newBestStreak,
      gamesPlayed: newGamesPlayed
    });

    try {
      setLoading(true);
      await fetch(`${API_URL}/leaderboard`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: userProfile.name,
          score: score,
          questionsAnswered: questions.length
        })
      });
      await fetchLeaderboard();
    } catch (error) {
      console.error('Error submitting score:', error);
    } finally {
      setLoading(false);
      setGameComplete(true);
    }
  };

  const goHome = () => {
    setScreen('home');
    setGameComplete(false);
    setSelectedCategory(null);
  };

  const openProfile = () => {
    setTempName(userProfile.name);
    setScreen('profile');
  };

  const saveProfile = () => {
    if (tempName.trim()) {
      updateProfile({ name: tempName.trim() });
    }
    setScreen('home');
  };

  // HOME SCREEN
  if (screen === 'home') {
    return (
      <div className="app">
        <button onClick={toggleMute} className="mute-button" title={isMuted ? "Unmute" : "Mute"}>
          {isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
        </button>

        <div className="home-screen">
          <div className="logo-section">
            <div className="logo-icon">
              <BookOpen size={48} />
            </div>
            <h1 className="main-title">WIZDOM</h1>
            <p className="subtitle">Bible Trivia</p>
          </div>

          <div className="profile-card">
            <div className="profile-header">
              <div className="avatar" style={{ backgroundColor: userProfile?.avatar.color }}>
                {userProfile?.avatar.initial}
              </div>
              <div className="profile-info">
                <h2>{userProfile?.name}</h2>
                <p>Welcome back!</p>
              </div>
            </div>

            <div className="stats-grid">
              <div className="stat-card">
                <Star size={24} />
                <div className="stat-value">{userProfile?.totalPoints.toLocaleString()}</div>
                <div className="stat-label">Points</div>
              </div>
              <div className="stat-card">
                <Zap size={24} />
                <div className="stat-value">{userProfile?.bestStreak}</div>
                <div className="stat-label">Best Streak</div>
              </div>
              <div className="stat-card">
                <Trophy size={24} />
                <div className="stat-value">{userProfile?.gamesPlayed}</div>
                <div className="stat-label">Games</div>
              </div>
            </div>
          </div>

          <button onClick={() => setScreen('categories')} className="play-button">
            ▶ PLAY NOW
          </button>

          <div className="action-buttons">
            <button onClick={() => setScreen('leaderboard')} className="action-btn">
              <Trophy size={20} />
              Leaderboard
            </button>
            <button onClick={openProfile} className="action-btn">
              <User size={20} />
              Profile
            </button>
          </div>

          <p className="tagline">Test your Bible knowledge • Compete with friends • Have fun!</p>
        </div>

        <style jsx>{`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          .app {
            min-height: 100vh;
            background: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%);
            font-family: 'Poppins', 'SF Pro Display', -apple-system, sans-serif;
            position: relative;
            overflow-x: hidden;
          }

          .mute-button {
            position: fixed;
            top: 1.5rem;
            right: 1.5rem;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 1000;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          }

          .mute-button:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: scale(1.1);
          }

          .mute-button:active {
            transform: scale(0.95);
          }

          .home-screen {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 2rem;
            padding-top: 3rem;
          }

          .logo-section {
            text-align: center;
            margin-bottom: 2rem;
            animation: fadeInDown 0.6s ease-out;
          }

          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .logo-icon {
            width: 80px;
            height: 80px;
            background: linear-gradient(135deg, #FFA500 0%, #FF8C00 100%);
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            margin: 0 auto 1rem;
            box-shadow: 0 10px 30px rgba(255, 165, 0, 0.3);
          }

          .main-title {
            font-size: 3rem;
            font-weight: 900;
            color: white;
            letter-spacing: 2px;
            margin-bottom: 0.25rem;
            text-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          }

          .subtitle {
            font-size: 1.25rem;
            color: rgba(255, 255, 255, 0.9);
            font-weight: 600;
          }

          .profile-card {
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(20px);
            border-radius: 25px;
            padding: 1.5rem;
            width: 100%;
            max-width: 400px;
            margin-bottom: 1.5rem;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
            border: 2px solid rgba(255, 255, 255, 0.2);
            animation: fadeInUp 0.6s ease-out 0.2s both;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .profile-header {
            display: flex;
            align-items: center;
            gap: 1rem;
            margin-bottom: 1.5rem;
          }

          .avatar {
            width: 60px;
            height: 60px;
            border-radius: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.75rem;
            font-weight: 900;
            color: white;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          }

          .profile-info h2 {
            font-size: 1.25rem;
            font-weight: 700;
            color: white;
            margin-bottom: 0.25rem;
          }

          .profile-info p {
            font-size: 0.9rem;
            color: rgba(255, 255, 255, 0.8);
          }

          .stats-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0.75rem;
          }

          .stat-card {
            background: rgba(255, 255, 255, 0.2);
            border-radius: 15px;
            padding: 1rem 0.5rem;
            text-align: center;
            border: 1px solid rgba(255, 255, 255, 0.3);
            transition: transform 0.2s ease;
          }

          .stat-card:hover {
            transform: translateY(-2px);
          }

          .stat-card svg {
            color: #FFD700;
            margin-bottom: 0.5rem;
          }

          .stat-value {
            font-size: 1.5rem;
            font-weight: 900;
            color: white;
            margin-bottom: 0.25rem;
          }

          .stat-label {
            font-size: 0.75rem;
            color: rgba(255, 255, 255, 0.8);
            font-weight: 600;
          }

          .play-button {
            width: 100%;
            max-width: 400px;
            padding: 1.25rem;
            font-size: 1.25rem;
            font-weight: 900;
            background: linear-gradient(135deg, #FFA500 0%, #FF8C00 100%);
            color: white;
            border: none;
            border-radius: 20px;
            cursor: pointer;
            box-shadow: 0 10px 30px rgba(255, 165, 0, 0.4);
            transition: all 0.3s ease;
            margin-bottom: 1rem;
            animation: fadeInUp 0.6s ease-out 0.4s both;
            letter-spacing: 1px;
          }

          .play-button:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 40px rgba(255, 165, 0, 0.5);
          }

          .play-button:active {
            transform: translateY(-1px);
          }

          .action-buttons {
            display: flex;
            gap: 1rem;
            margin-bottom: 2rem;
            animation: fadeInUp 0.6s ease-out 0.6s both;
          }

          .action-btn {
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
            color: white;
            padding: 0.875rem 1.5rem;
            border-radius: 15px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-weight: 600;
            font-size: 0.95rem;
            transition: all 0.3s ease;
          }

          .action-btn:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateY(-2px);
          }

          .tagline {
            color: rgba(255, 255, 255, 0.7);
            font-size: 0.9rem;
            text-align: center;
            max-width: 400px;
            animation: fadeInUp 0.6s ease-out 0.8s both;
          }

          @media (max-width: 600px) {
            .main-title {
              font-size: 2.5rem;
            }

            .stats-grid {
              grid-template-columns: repeat(3, 1fr);
            }

            .stat-value {
              font-size: 1.25rem;
            }

            .action-buttons {
              flex-direction: column;
              width: 100%;
              max-width: 400px;
            }

            .action-btn {
              width: 100%;
              justify-content: center;
            }
          }
        `}</style>
      </div>
    );
  }

  // CATEGORY SELECTION SCREEN
  if (screen === 'categories') {
    const categories = Object.keys(CATEGORY_INFO);
    
    return (
      <div className="app">
        <button onClick={toggleMute} className="mute-button" title={isMuted ? "Unmute" : "Mute"}>
          {isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
        </button>

        <div className="categories-screen">
          <button onClick={goHome} className="back-btn">
            <ArrowLeft size={20} />
            Home
          </button>

          <div className="category-header">
            <h1>Choose Category</h1>
            <p>Pick your challenge!</p>
          </div>

          <div className="category-grid">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => startGame(category)}
                className="category-card"
                style={{ background: `linear-gradient(135deg, ${CATEGORY_INFO[category].color}dd 0%, ${CATEGORY_INFO[category].color} 100%)` }}
              >
                <span className="category-icon">{CATEGORY_INFO[category].icon}</span>
                <span className="category-name">{category}</span>
              </button>
            ))}
          </div>

          <button onClick={() => startGame('Mix It Up')} className="mix-button">
            <Sparkles size={20} />
            Mix It Up!
            <Sparkles size={20} />
          </button>
        </div>

        <style jsx>{`
          .app {
            min-height: 100vh;
            background: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%);
            font-family: 'Poppins', 'SF Pro Display', -apple-system, sans-serif;
            position: relative;
            overflow-x: hidden;
          }

          .mute-button {
            position: fixed;
            top: 1.5rem;
            right: 1.5rem;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 1000;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          }

          .mute-button:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: scale(1.1);
          }

          .mute-button:active {
            transform: scale(0.95);
          }

          .categories-screen {
            min-height: 100vh;
            padding: 2rem;
            padding-top: 4rem;
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .back-btn {
            position: absolute;
            top: 1.5rem;
            left: 1.5rem;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
            color: white;
            padding: 0.75rem 1.25rem;
            border-radius: 15px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-weight: 600;
            transition: all 0.3s ease;
          }

          .back-btn:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateX(-3px);
          }

          .category-header {
            text-align: center;
            margin-bottom: 2.5rem;
            animation: fadeInDown 0.6s ease-out;
          }

          .category-header h1 {
            font-size: 2.5rem;
            font-weight: 900;
            color: white;
            margin-bottom: 0.5rem;
            text-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          }

          .category-header p {
            font-size: 1.1rem;
            color: rgba(255, 255, 255, 0.9);
            font-weight: 600;
          }

          .category-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;
            max-width: 500px;
            width: 100%;
            margin-bottom: 1.5rem;
            animation: fadeInUp 0.6s ease-out 0.2s both;
          }

          .category-card {
            aspect-ratio: 1;
            border: none;
            border-radius: 25px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 0.75rem;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
            color: white;
            font-weight: 700;
            font-size: 1rem;
          }

          .category-card:hover {
            transform: translateY(-5px) scale(1.02);
            box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3);
          }

          .category-card:active {
            transform: translateY(-3px) scale(1.01);
          }

          .category-icon {
            font-size: 2.5rem;
          }

          .category-name {
            text-align: center;
            line-height: 1.2;
          }

          .mix-button {
            background: linear-gradient(90deg, #8B5CF6 0%, #EC4899 100%);
            color: white;
            border: none;
            padding: 1.25rem 2.5rem;
            border-radius: 20px;
            font-size: 1.25rem;
            font-weight: 900;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.75rem;
            box-shadow: 0 10px 30px rgba(236, 72, 153, 0.4);
            transition: all 0.3s ease;
            margin-top: 1rem;
            animation: fadeInUp 0.6s ease-out 0.4s both;
          }

          .mix-button:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 40px rgba(236, 72, 153, 0.5);
          }

          @media (max-width: 600px) {
            .category-grid {
              grid-template-columns: repeat(2, 1fr);
            }

            .category-header h1 {
              font-size: 2rem;
            }
          }
        `}</style>
      </div>
    );
  }

  // PROFILE SCREEN
  if (screen === 'profile') {
    return (
      <div className="app">
        <div className="profile-screen">
          <button onClick={goHome} className="back-btn">
            <ArrowLeft size={20} />
            Home
          </button>

          <div className="profile-content">
            <h1>Profile</h1>

            <div className="profile-edit-card">
              <div className="avatar-large" style={{ backgroundColor: userProfile?.avatar.color }}>
                {userProfile?.avatar.initial}
              </div>

              <div className="edit-section">
                <label>Name</label>
                <input
                  type="text"
                  value={tempName}
                  onChange={(e) => setTempName(e.target.value)}
                  maxLength={20}
                  className="name-input"
                />
              </div>

              <button onClick={saveProfile} className="save-btn">
                Save Changes
              </button>
            </div>

            <div className="stats-summary">
              <h2>Your Stats</h2>
              <div className="stat-row">
                <span>Total Points</span>
                <strong>{userProfile?.totalPoints.toLocaleString()}</strong>
              </div>
              <div className="stat-row">
                <span>Best Streak</span>
                <strong>{userProfile?.bestStreak}</strong>
              </div>
              <div className="stat-row">
                <span>Games Played</span>
                <strong>{userProfile?.gamesPlayed}</strong>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .app {
            min-height: 100vh;
            background: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%);
            font-family: 'Poppins', 'SF Pro Display', -apple-system, sans-serif;
            position: relative;
            overflow-x: hidden;
          }

          .mute-button {
            position: fixed;
            top: 1.5rem;
            right: 1.5rem;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 1000;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          }

          .mute-button:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: scale(1.1);
          }

          .mute-button:active {
            transform: scale(0.95);
          }

          .back-btn {
            position: absolute;
            top: 1.5rem;
            left: 1.5rem;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border: 2px solid rgba(255, 255, 255, 0.3);
            color: white;
            padding: 0.75rem 1.25rem;
            border-radius: 15px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-weight: 600;
            transition: all 0.3s ease;
          }

          .back-btn:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateX(-3px);
          }

          .profile-screen {
            min-height: 100vh;
            padding: 2rem;
            padding-top: 4rem;
          }

          .profile-content {
            max-width: 500px;
            margin: 0 auto;
          }

          .profile-content h1 {
            color: white;
            font-size: 2.5rem;
            font-weight: 900;
            text-align: center;
            margin-bottom: 2rem;
            text-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          }

          .profile-edit-card {
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(20px);
            border-radius: 25px;
            padding: 2rem;
            border: 2px solid rgba(255, 255, 255, 0.2);
            margin-bottom: 1.5rem;
          }

          .avatar-large {
            width: 100px;
            height: 100px;
            border-radius: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 3rem;
            font-weight: 900;
            color: white;
            margin: 0 auto 2rem;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
          }

          .edit-section {
            margin-bottom: 1.5rem;
          }

          .edit-section label {
            display: block;
            color: white;
            font-weight: 600;
            margin-bottom: 0.5rem;
            font-size: 0.9rem;
          }

          .name-input {
            width: 100%;
            padding: 1rem;
            border-radius: 15px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            background: rgba(255, 255, 255, 0.9);
            color: #333;
            font-size: 1.1rem;
            font-weight: 600;
            font-family: inherit;
          }

          .name-input:focus {
            outline: none;
            border-color: #FFA500;
            background: white;
            box-shadow: 0 0 0 4px rgba(255, 165, 0, 0.2);
          }

          .name-input::placeholder {
            color: rgba(51, 51, 51, 0.5);
          }

          .save-btn {
            width: 100%;
            padding: 1rem;
            background: linear-gradient(135deg, #FFA500 0%, #FF8C00 100%);
            color: white;
            border: none;
            border-radius: 15px;
            font-size: 1.1rem;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 6px 20px rgba(255, 165, 0, 0.4);
          }

          .save-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(255, 165, 0, 0.5);
          }

          .stats-summary {
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(20px);
            border-radius: 25px;
            padding: 2rem;
            border: 2px solid rgba(255, 255, 255, 0.2);
          }

          .stats-summary h2 {
            color: white;
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 1.5rem;
          }

          .stat-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1rem;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 12px;
            margin-bottom: 0.75rem;
            color: white;
          }

          .stat-row:last-child {
            margin-bottom: 0;
          }

          .stat-row span {
            font-weight: 500;
          }

          .stat-row strong {
            font-size: 1.25rem;
            font-weight: 900;
          }
        `}</style>
      </div>
    );
  }

  // LEADERBOARD SCREEN
  if (screen === 'leaderboard') {
    return (
      <div className="app">
        <div className="leaderboard-screen">
          <button onClick={goHome} className="back-btn">
            <ArrowLeft size={20} />
            Home
          </button>

          <div className="leaderboard-header">
            <Trophy className="trophy-icon" />
            <h1>Top Players</h1>
          </div>

          <div className="leaderboard-card">
            {loading ? (
              <div className="loading-container">
                <div className="loading-spinner">Loading...</div>
              </div>
            ) : leaderboard.length === 0 ? (
              <p className="no-scores">No scores yet. Be the first to play!</p>
            ) : (
              <div className="leaderboard-list">
                {leaderboard.map((entry, index) => (
                  <div key={index} className={`leaderboard-entry rank-${index + 1}`}>
                    <div className="rank">
                      {index === 0 && <Crown className="crown" />}
                      {index + 1}
                    </div>
                    <div className="player-info">
                      <div className="player-name">{entry.name}</div>
                      <div className="player-date">
                        {entry.date ? new Date(entry.date).toLocaleDateString() : 'Recent'}
                      </div>
                    </div>
                    <div className="player-score">{entry.score}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <style jsx>{`
          .leaderboard-screen {
            min-height: 100vh;
            padding: 2rem;
            padding-top: 4rem;
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .leaderboard-header {
            text-align: center;
            margin-bottom: 2rem;
          }

          .trophy-icon {
            width: 64px;
            height: 64px;
            color: #FFD700;
            margin-bottom: 1rem;
            animation: bounce 2s ease-in-out infinite;
          }

          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }

          .leaderboard-header h1 {
            font-size: 2.5rem;
            color: white;
            font-weight: 900;
            text-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          }

          .leaderboard-card {
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(20px);
            border-radius: 25px;
            padding: 2rem;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
            border: 2px solid rgba(255, 255, 255, 0.2);
            min-width: 450px;
            max-width: 600px;
            width: 100%;
            min-height: 400px;
          }

          .loading-container {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 300px;
          }

          .loading-spinner {
            font-size: 1.2rem;
            color: white;
            font-weight: 700;
            animation: pulse 1.5s ease-in-out infinite;
          }

          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }

          .no-scores {
            text-align: center;
            color: rgba(255, 255, 255, 0.7);
            font-size: 1.1rem;
            padding: 2rem;
          }

          .leaderboard-list {
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
          }

          .leaderboard-entry {
            display: flex;
            align-items: center;
            gap: 1rem;
            padding: 1.25rem;
            border-radius: 15px;
            background: rgba(255, 255, 255, 0.2);
            border: 1px solid rgba(255, 255, 255, 0.3);
            transition: all 0.3s ease;
          }

          .leaderboard-entry:hover {
            transform: translateX(5px);
            background: rgba(255, 255, 255, 0.25);
          }

          .rank-1 {
            background: linear-gradient(135deg, #FFD700dd 0%, #FFA500 100%);
            border: 2px solid #FFD700;
          }

          .rank-2 {
            background: linear-gradient(135deg, #C0C0C0dd 0%, #999999 100%);
            border: 2px solid #C0C0C0;
          }

          .rank-3 {
            background: linear-gradient(135deg, #CD7F32dd 0%, #996633 100%);
            border: 2px solid #CD7F32;
          }

          .rank {
            font-size: 1.5rem;
            font-weight: 900;
            min-width: 50px;
            text-align: center;
            color: white;
            position: relative;
          }

          .crown {
            position: absolute;
            top: -25px;
            left: 50%;
            transform: translateX(-50%);
            width: 24px;
            height: 24px;
            color: #FFD700;
          }

          .player-info {
            flex: 1;
          }

          .player-name {
            font-size: 1.1rem;
            font-weight: 700;
            color: white;
            margin-bottom: 0.25rem;
          }

          .player-date {
            font-size: 0.85rem;
            color: rgba(255, 255, 255, 0.7);
          }

          .player-score {
            font-size: 1.5rem;
            font-weight: 900;
            color: white;
          }

          @media (max-width: 600px) {
            .leaderboard-card {
              min-width: auto;
            }
          }
        `}</style>
      </div>
    );
  }

  // GAME SCREEN
  if (screen === 'game') {
    const question = questions[currentQuestion];
    const categoryColor = CATEGORY_INFO[question.category].color;

    if (gameComplete) {
      return (
        <div className="app">
          <div className="results-screen">
            <div className="results-card">
              {loading ? (
                <div className="loading-spinner">Saving score...</div>
              ) : (
                <>
                  <Trophy className="results-trophy" />
                  <h1 className="results-title">Game Complete!</h1>
                  <div className="final-score">{score} points</div>
                  <p className="results-message">
                    {score >= 2000 ? 'Amazing! You\'re a Bible scholar!' :
                     score >= 1500 ? 'Great job! You know your scripture!' :
                     score >= 1000 ? 'Good work! Keep studying!' :
                     'Nice try! Play again to improve!'}
                  </p>
                  <div className="results-buttons">
                    <button onClick={() => startGame(selectedCategory)} className="play-again-button">
                      <Zap className="button-icon" />
                      Play Again
                    </button>
                    <button onClick={goHome} className="home-button">
                      <Home className="button-icon" />
                      Home
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>

          <style jsx>{`
            .results-screen {
              min-height: 100vh;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 2rem;
            }

            .results-card {
              background: rgba(255, 255, 255, 0.15);
              backdrop-filter: blur(20px);
              border-radius: 30px;
              padding: 3rem;
              box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
              border: 2px solid rgba(255, 255, 255, 0.2);
              text-align: center;
              animation: scaleIn 0.6s ease-out;
              min-height: 400px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            }

            @keyframes scaleIn {
              from {
                opacity: 0;
                transform: scale(0.8);
              }
              to {
                opacity: 1;
                transform: scale(1);
              }
            }

            .loading-spinner {
              font-size: 1.5rem;
              color: white;
              font-weight: 700;
              animation: pulse 1.5s ease-in-out infinite;
            }

            .results-trophy {
              width: 80px;
              height: 80px;
              color: #FFD700;
              margin-bottom: 1rem;
              animation: bounce 2s ease-in-out infinite;
            }

            .results-title {
              font-size: 2.5rem;
              color: white;
              margin-bottom: 1rem;
              font-weight: 900;
            }

            .final-score {
              font-size: 4rem;
              font-weight: 900;
              background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              margin-bottom: 1rem;
            }

            .results-message {
              font-size: 1.2rem;
              color: rgba(255, 255, 255, 0.9);
              margin-bottom: 2rem;
            }

            .results-buttons {
              display: flex;
              gap: 1rem;
              justify-content: center;
              flex-wrap: wrap;
            }

            .play-again-button, .home-button {
              padding: 1rem 2rem;
              font-size: 1.1rem;
              font-weight: 700;
              border: none;
              border-radius: 15px;
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 0.5rem;
              transition: all 0.3s ease;
              font-family: inherit;
            }

            .play-again-button {
              background: linear-gradient(135deg, #FFA500 0%, #FF8C00 100%);
              color: white;
              box-shadow: 0 6px 20px rgba(255, 165, 0, 0.4);
            }

            .play-again-button:hover {
              transform: translateY(-3px);
              box-shadow: 0 10px 30px rgba(255, 165, 0, 0.5);
            }

            .home-button {
              background: rgba(255, 255, 255, 0.2);
              backdrop-filter: blur(10px);
              border: 2px solid rgba(255, 255, 255, 0.3);
              color: white;
            }

            .home-button:hover {
              background: rgba(255, 255, 255, 0.3);
              transform: translateY(-3px);
            }

            .button-icon {
              width: 20px;
              height: 20px;
            }
          `}</style>
        </div>
      );
    }

    return (
      <div className="app">
        <div className="game-screen">
          <div className="game-header">
            <div className="score-display">
              <Star className="score-icon" />
              <span>{score}</span>
            </div>
            {currentStreak >= 3 && (
              <div className="streak-display">
                <Zap className="streak-icon" />
                <span>{currentStreak} Streak!</span>
              </div>
            )}
            <div className="question-counter">
              {currentQuestion + 1} / {questions.length}
            </div>
          </div>

          <div className="question-card" style={{ borderTopColor: categoryColor }}>
            <div className="category-badge" style={{ backgroundColor: categoryColor }}>
              {CATEGORY_INFO[question.category].icon} {question.category}
            </div>
            
            <div className="question-text">
              {question.question}
            </div>

            <div className="options-grid">
              {question.options.map((option, index) => {
                let className = 'option-button';
                if (showResult) {
                  if (index === question.correct) {
                    className += ' correct';
                  } else if (index === selectedAnswer) {
                    className += ' incorrect';
                  } else {
                    className += ' disabled';
                  }
                }
                
                return (
                  <button
                    key={index}
                    className={className}
                    onClick={() => handleAnswer(index)}
                    disabled={showResult}
                  >
                    {option}
                  </button>
                );
              })}
            </div>

            {showResult && (
              <div className={`result-message ${selectedAnswer === question.correct ? 'correct-msg' : 'incorrect-msg'}`}>
                {selectedAnswer === question.correct ? (
                  <>
                    <span className="result-icon">🎉</span>
                    <span>Correct! +{question.points}{currentStreak >= 3 && ' +50 Streak Bonus!'}</span>
                  </>
                ) : (
                  <>
                    <span className="result-icon">💭</span>
                    <span>The answer was: {question.options[question.correct]}</span>
                  </>
                )}
              </div>
            )}
          </div>
        </div>

        <style jsx>{`
          .game-screen {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 2rem;
            padding-top: 6rem;
          }

          .game-header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            background: rgba(139, 92, 246, 0.95);
            backdrop-filter: blur(10px);
            padding: 1.5rem 2rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            z-index: 10;
          }

          .score-display {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 1.5rem;
            font-weight: 900;
            color: white;
          }

          .score-icon {
            width: 28px;
            height: 28px;
            color: #FFD700;
          }

          .streak-display {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 1rem;
            background: linear-gradient(135deg, #FFA500 0%, #FF8C00 100%);
            color: white;
            border-radius: 20px;
            font-weight: 700;
            animation: pulse 1s ease-in-out infinite;
          }

          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }

          .streak-icon {
            width: 20px;
            height: 20px;
          }

          .question-counter {
            font-size: 1.2rem;
            font-weight: 700;
            color: white;
          }

          .question-card {
            background: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(20px);
            border-radius: 30px;
            padding: 2.5rem;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
            border: 2px solid rgba(255, 255, 255, 0.2);
            max-width: 700px;
            width: 100%;
            border-top: 8px solid;
            animation: slideUp 0.6s ease-out;
          }

          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .category-badge {
            display: inline-block;
            padding: 0.5rem 1.5rem;
            border-radius: 20px;
            color: white;
            font-weight: 700;
            margin-bottom: 1.5rem;
            font-size: 0.95rem;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          }

          .question-text {
            font-size: 1.6rem;
            font-weight: 700;
            color: #1a1a1a;
            margin-bottom: 2rem;
            line-height: 1.4;
            text-shadow: none;
          }

          .options-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1rem;
            margin-bottom: 1.5rem;
          }

          .option-button {
            padding: 1.5rem;
            font-size: 1.05rem;
            font-weight: 600;
            border: 2px solid #8B5CF6;
            border-radius: 15px;
            background: #F3F4F6;
            color: #1a1a1a;
            cursor: pointer;
            transition: all 0.3s ease;
            font-family: inherit;
          }

          .option-button:hover:not(.disabled) {
            transform: translateY(-3px);
            background: #E5E7EB;
            box-shadow: 0 6px 20px rgba(139, 92, 246, 0.3);
            border-color: #7C3AED;
          }

          .option-button:active:not(.disabled) {
            transform: translateY(-1px);
          }

          .option-button.correct {
            background: linear-gradient(135deg, #7DCEA0 0%, #56C596 100%);
            border-color: #56C596;
            animation: correctAnswer 0.6s ease-out;
          }

          @keyframes correctAnswer {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }

          .option-button.incorrect {
            background: linear-gradient(135deg, #FF8E8E 0%, #FF6B6B 100%);
            border-color: #FF6B6B;
            animation: shake 0.5s ease-out;
          }

          @keyframes shake {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-10px); }
            75% { transform: translateX(10px); }
          }

          .option-button.disabled {
            opacity: 0.4;
            cursor: not-allowed;
          }

          .result-message {
            padding: 1.5rem;
            border-radius: 15px;
            font-size: 1.1rem;
            font-weight: 700;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 1rem;
            animation: slideUp 0.4s ease-out;
          }

          .correct-msg {
            background: linear-gradient(135deg, #7DCEA0 0%, #56C596 100%);
            color: #064E3B;
          }

          .incorrect-msg {
            background: linear-gradient(135deg, #FFD3D3 0%, #FFA5A5 100%);
            color: #991B1B;
          }

          .result-icon {
            font-size: 2rem;
          }

          @media (max-width: 600px) {
            .question-card {
              padding: 2rem;
            }

            .question-text {
              font-size: 1.3rem;
            }

            .options-grid {
              grid-template-columns: 1fr;
            }

            .game-header {
              padding: 1rem;
              flex-wrap: wrap;
              gap: 0.5rem;
            }

            .streak-display {
              order: 3;
              width: 100%;
              justify-content: center;
            }
          }
        `}</style>
      </div>
    );
  }
};

export default WizdomTrivia;
